const noGrouping = 'useGrouping: false;';
const grouping = 'useGrouping: true;';

const integer = 'minimumFractionDigits: 0; maximumFractionDigits: 0';
const tenth = 'minimumFractionDigits: 1; maximumFractionDigits: 1';
const hundredth = 'minimumFractionDigits: 2; maximumFractionDigits: 2';

const currency = `style: currency; currency: EUR;`;
const currencyNoGrouping = `${currency} ${noGrouping}`;
const currencyGrouping = `${currency} ${grouping}`;

const percent = 'style: percent;';

export const number = {
  decimal: {
    // 1 000
    grouping_integer: `{{ value, number(${grouping} ${integer}) }}`,
    // 1 000 or 1 000,5 (flexible)
    grouping_flexible: `{{ value, number(${grouping} minimumFractionDigits: 0; maximumFractionDigits: 2) }}`,
    // Preserves up to 10 significant digits (for quantities/parts)
    grouping_significant: `{{ value, number(${grouping} maximumSignificantDigits: 10) }}`,
    // 1 000 or 1 000,5 (flexible, max 1 decimal)
    noGrouping_flexibleTenth:
      '{{value, number(useGrouping: true; minimumFractionDigits: 1; maximumFractionDigits: 1; trailingZeroDisplay: stripIfInteger)}}',
  },

  currency: {
    // 1 000 €
    noGrouping_integer: `{{ value, number(${currencyGrouping} ${integer}) }}`,
    // 1 000,0 €
    noGrouping_tenth: `{{ value, number(${currencyGrouping} ${tenth}) }}`,
    // 1 000,00 €
    noGrouping_hundredth: `{{ value, number(${currencyGrouping} ${hundredth}) }}`,
    // 1 000 € or 1 000,50 € (flexible)
    noGrouping_flexible:
      '{{value, number(useGrouping: true; minimumFractionDigits: 2; maximumFractionDigits: 2; trailingZeroDisplay: stripIfInteger)}}\u00A0€',

    // 1000 €
    grouping_integer: `{{ value, number(${currencyNoGrouping} ${integer}) }}`,
    // 1000,0 €
    grouping_tenth: `{{ value, number(${currencyNoGrouping} ${tenth}) }}`,
    // 1000,00 €
    grouping_hundredth: `{{ value, number(${currencyNoGrouping} ${hundredth}) }}`,
  },
  percent: {
    // 300 %
    noGrouping_integer: `{{ value, number(${percent} ${integer}) }}`,
    // 300.0 %
    noGrouping_tenth: `{{ value, number(${percent} ${tenth}) }}`,
    // 300.00 %
    noGrouping_hundredth: `{{ value, number(${percent} ${hundredth}) }}`,
    noGrouping_flexible:
      '{{value, number(useGrouping: true; minimumFractionDigits: 2; maximumFractionDigits: 2; trailingZeroDisplay: stripIfInteger)}}\u00A0%',
  },
};
